import { useRef } from "react";
import useAuth from "./useAuth";
import axios from "../api/axios";
import useCommonFunctionHooks from "./useCommonFunctionHooks";
import { getDataFromStorage } from "../util";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const subscribers = useRef([]);
  const isRefreshing = useRef(false);
  const { getCatchBlockDetails } = useCommonFunctionHooks();

  const notifySub = (token, error = null) => {
    subscribers.current.forEach((callback) => {
      if (error) {
        callback(null, error);
      } else {
        callback(token, null);
      }
    });
    subscribers.current = [];
  };

  const refresh = async () => {
    if (isRefreshing.current) {
      return new Promise((resolve, reject) => {
        subscribers.current.push((token, error) => {
          if (error) {
            reject(error);
          } else {
            resolve(token);
          }
        });
      });
    }

    isRefreshing.current = true; //setting flag to true

    try {
      const response = await axios.post(
        "node/auth/accesstoken/new",
        { refreshToken: localStorage.getItem("refreshToken") },
        {
          headers: {
            Authorization: "abdjcdifouvn",
            "Content-Type": "application/json",
            "x-company-id" : getDataFromStorage("companyId")
          },
        }
      );

      const newAccessToken = response.data.accessToken;

      setAuth((prev) => ({
        ...prev,
        token: newAccessToken,
      }));

      notifySub(newAccessToken);

      return newAccessToken;
    } catch (err) {
      getCatchBlockDetails(err);
      notifySub(null, err);
      throw err; //rethrow the error
    } finally {
      isRefreshing.current = false; //reset flag to false
    }
  };

  return refresh;
};

export default useRefreshToken;
